function parseLine(line) {
    const parts = line.split(/(<b>.*?<\/b>)/g).filter(Boolean);

    return parts.map((part, index) => {
        const boldMatch = part.match(/^<b>(.*?)<\/b>$/);

        if (boldMatch) {
            return <strong key={index}>{boldMatch[1]}</strong>;
        }

        return <span key={index} className="">{part}</span>;
    });
}

export default function ReportContent({ data }) {
    const occurrences = data?.occ ?? [];

    return (
        <>
            <h2 className="-mt-2 ml-5">
                <strong>OCORRÊNCIA{" "}</strong>
                <span>{data.id ?? ""}</span>
            </h2>
            <div className="chart-divisor mt-2! mb-2!"/>
            <div className="space-y-2 text-sm pl-6">
                {occurrences.map((item, occIndex) => {
                    const lines = (item?.text ?? "")
                        .split("\n")
                        .map(line => line.trimEnd())
                        .filter(line => line.trim() !== "");

                    return (
                        <div key={occIndex}>
                            <span className="font-bold text-[18px]">
                                {item?.title ?? ""}
                            </span>
                            <div className="mt-2">
                                {lines.map((line, lineIndex) => {
                                    const isBlockTitle = line.trimStart().startsWith("<b>");

                                    return (
                                        <div
                                            key={lineIndex}
                                            className={isBlockTitle && lineIndex !== 0 ? "mt-2" : ""}
                                        >
                                            {parseLine(line)}
                                        </div>
                                    );
                                })}
                            </div>
                            <div className="chart-divisor mt-3!" />
                        </div>
                    );
                })}
            </div>
        </>
    )
}